import React, { useCallback } from 'react';
import { FormControlLabel, RadioGroup, Radio as Radio$1 } from '@hermes/web-components';

const Radio = ({ defaultValue, options = [], label, onChange }) => {
    const handleChange = useCallback((_, value) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    }, []);
    return (React.createElement(FormControlLabel, { sx: { alignItems: 'flex-start', paddingLeft: '12px' }, control: React.createElement(RadioGroup, { "aria-labelledby": `${label}-radio-group`, defaultValue: defaultValue, name: `${label}-radio-group`, onChange: handleChange }, options.map((option) => (React.createElement(FormControlLabel, { value: option.value, control: React.createElement(Radio$1, { sx: {
                    '&.Mui-checked': {
                        color: '#1A3586',
                    },
                } }), label: option.label })))), label: label }));
};

export { Radio as default };
